module.exports = __webpack_public_path__ + "assets/f4aa0854811692beb3135f2f97b04a1f.eot";